import { NsColumn } from '@britishgasenergy/react-nucleus';

import { NsContent } from 'components/common/ns-content/NsContent';
import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { MeterpointGuideCta } from 'components/direct-sales/meterpoint-validation/components/MeterpointGuideCta';
import { NsCard } from 'components/common/ns-card/NsCard';
import {
  setMPAN,
  setMPRN
} from 'state/meterpoint-validation/meterpoint-validation-slice';
import { getMeterpointDetails } from 'state/meterpoint-validation/meterpoint-validation-thunks';
import { useMeterpointValidation } from 'components/direct-sales/meterpoint-validation/hooks/useMeterpointValidation';
import { Error } from 'components/common/error/Error';
import { NsForm } from 'components/common/ns-form/NsForm';
import { NsMpanInput } from 'components/common/ns-mpan-input/NsMpanInput';
import { NsMprnInput } from 'components/common/ns-mprn-input/NsMprnInput';
import { NsStopgap } from 'components/common/ns-stopgap/NsStopgap';
import { useNavigation } from 'hooks/useNavigation';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { MeterCard } from './MeterCard';
import { FUEL_OPTIONS } from 'config/app-config';

export const testId = 'MeterpointValidationTestId';

export const MeterpointValidationContent = () => {
  const dispatch = useAppDispatch();

  const { eventTypes, next } = useNavigation();

  const {
    electricityValidation,
    gasValidation,
    errors,
    isLoading,
    MPAN,
    MPRN,
    hasMissingAddress,
    hasElecAddress,
    hasGasAddress,
    elecAddress,
    gasAddress
  } = useMeterpointValidation();

  const showMpan = electricityValidation && !hasElecAddress;
  const showMprn = gasValidation && !hasGasAddress;

  const handleSubmit = async () => {
    if (!hasMissingAddress) {
      next({ eventType: eventTypes.NEXT });
    } else {
      try {
        await dispatch(
          getMeterpointDetails({
            ...(MPAN && { mpan: MPAN }),
            ...(MPRN && { mprn: MPRN })
          })
        );
      } catch (e) {
        e && console.error(e);
      }
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    name === 'MPRN' && dispatch(setMPRN(value));
    name === 'MPAN' && dispatch(setMPAN(value));
  };

  if (isLoading) {
    return <NsStopgap />;
  }

  return (
    <div data-testid={testId}>
      <NsCard>
        <NsContent>
          <h3>We need details about your meters</h3>
          <NsForm onSubmit={handleSubmit}>
            <p>
              To give you the best quote, we need your meter reference numbers
              which can be found on your current supplier’s mobile app, online
              account or energy bill. Need help? <MeterpointGuideCta />
            </p>

            <Error errors={errors} />
            <NsColumn>
              {hasElecAddress && (
                <NsColumn>
                  <MeterCard
                    shouldShow={hasElecAddress}
                    address={elecAddress}
                    fuelType={FUEL_OPTIONS.ELECTRIC}
                    mpxn={MPAN}
                  />
                </NsColumn>
              )}
              {hasGasAddress && (
                <NsColumn>
                  <MeterCard
                    shouldShow={hasGasAddress}
                    address={gasAddress}
                    fuelType={FUEL_OPTIONS.GAS}
                    mpxn={MPRN}
                  />
                </NsColumn>
              )}
            </NsColumn>
            {showMpan && (
              <NsMpanInput
                name="MPAN"
                value={MPAN}
                label="MPAN for electricity"
                onChange={handleChange}
              />
            )}
            {showMprn && (
              <NsMprnInput
                name="MPRN"
                value={MPRN}
                label="MPRN for gas"
                onChange={handleChange}
              />
            )}

            {!showMpan && !showMprn && (
              <p>
                Incorrect address? <br />
                Please double check your meter reference number.{' '}
                <MeterpointGuideCta /> for where to find it
              </p>
            )}

            <NsPrimaryCta isLoading={isLoading}>
              {!hasMissingAddress ? 'Confirm details' : 'Check details'}
            </NsPrimaryCta>
          </NsForm>
        </NsContent>
      </NsCard>
    </div>
  );
};

export default MeterpointValidationContent;
